import {DocTypes} from "myshubhlife-component/docInput";

export const docTypeMapWithSubStatus = {
    LATEST_PAYSLIP_MISSING: {
        docType: DocTypes.PAY_SLIP_1,
        heading: "Latest payslip",
        desc: "Please upload latest salary payslip",
    },
};
